export class GeoResponse {
  constructor(public data?: IpResponse[]) {}
}

export interface IpResponse {
  city: string;
  continent: string;
  country: string;
  currency: string;
  ip: string;
  iso_code: string;
  languages: any;
  lat: number;
  lon: number;
  phone_code: string;
  postal_code: string;
  state: string;
  state_name: string;
  timezone: string;
}
